import React from 'react'

import influencerData from '../../data-influencer/harrison'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Harrison = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Harrison
